module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAATFJREFUaEPtWNsNAjEM800CbMAmMAKbAJswAmzCCDAJyB8noXK6Jm3UqpL7e740tpO+Jgw+psHzhwj0dlAOyIFKBVRClQJW/2514ATgDGBrmPEF4ArglmAjYvxNbyXApDaG5GcI8bsEHxGjmMDHkfwMTcWJiCECHiPkAJA/q1mbOKJ+I2KoB9QDHgXUAz9qRTRgRIyuTXwHcHCU0APAMYdvuYwyl70lKQAk+8wlz++tCVhycmFEYEUuqzguxVOwdZKIFYQNyUsR+yA3WP+8FLEXVkdLArrQLFnR0oGIMuy6kYmASii3pCXfdSe2HHW0CjmOEl1XIe8u+l54R42IUbwP8GH2YnwfZfLELj3u1sYoJuBcgNrBrU3cLiPnTCLgFCwcLgfCJXUGlANOwcLhwzvwBW11SjHXORPXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main_board_icon_off.png
// module id = aY9l
// module chunks = 3